module.exports = __webpack_public_path__ + "static/media/shoes.f7e59885.webp";